import * as React from "react";
import { useSelector } from "react-redux";
import { Label } from "semantic-ui-react";

import { getOhCaseDocumentCount } from "../../actions";
import { ohCaseSelector } from "../../selectors";

export const DocumentsLabel = (props: { customerId: string; ohCaseId: string }) => {
    const ohCase = useSelector(ohCaseSelector);
    const [documentCount, setDocumentCount] = React.useState<number | undefined>(ohCase.documents?.length);

    React.useEffect(() => {
        const getDocumentCount = async () => {
            const result = await getOhCaseDocumentCount(props.customerId, props.ohCaseId);
            setDocumentCount(result);
        };

        if (ohCase.documents && ohCase.documents.length > 0) {
            setDocumentCount(ohCase.documents.length);
        } else if (!documentCount) {
            getDocumentCount();
        }

    }, [documentCount, props.customerId, props.ohCaseId, ohCase.documents]);

    if (!documentCount || documentCount === 0)
    {
        return null;
    }

    return (
        <Label circular color="red" floating className="document-label">{documentCount}</Label>
    );
};
